import { AddCircle } from "@mui/icons-material";
import { FC, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { selectClientLens, selectClientLensAssignees } from "redux/slices/clientLens";
import { selectMyUserId } from "redux/slices/session";
import theme from "theme";
import CreateCase from "routes/lenses/lens/CreateCase";
import { ManagementCard } from "routes/lenses/lens/admin/management/ManagementCard";

const AddCase: FC = () => {
  const [createCase, setCreateCase] = useState<boolean>(false);
  const clientLens = useAppSelector(selectClientLens);
  const assignees = useAppSelector(selectClientLensAssignees);
  const myUserId = useAppSelector(selectMyUserId);
  const myAssignee = assignees.find((a) => a.id === myUserId);

  return (
    <>
      <ManagementCard
        title="Add Case"
        onClick={() => setCreateCase(true)}
        Icon={AddCircle}
        color={theme.palette.grey[900]}
        id="lens-admin-management-add-case"
      />
      {createCase && (
        <CreateCase onCancel={() => setCreateCase(false)} lens={clientLens} initialAssignee={myAssignee} />
      )}
    </>
  );
};

export default AddCase;
